import React from 'react';
import { Route, Switch } from 'react-router-dom';
import loadable from '@loadable/component'
import MainWrapper from './MainWrapper';
import PrivateRoute from './PrivateRoute'
import { useAuthToken } from "@common/components"
import LoginRoute from './LoginRoute';
import { Utils } from "@common/utils/"
import { Auth0Config } from "@common/auth/";
import { Auth0Provider } from "@auth0/auth0-react";
import Loading from "./Loading";
import { MULTI_PRODUCT_ROUTES } from './UnifiedMenu/multi-product-routes';

const AttributesApp = loadable(() => import(/* webpackChunkName: "attributes-chunk" */ './apps-routes/AttributesApp'));
const ValidationApp = loadable(() => import(/* webpackChunkName: "validation-chunk" */ './apps-routes/ValidationApp'));
const ValidationApprovalApp = loadable(() => import(/* webpackChunkName: "validation-approval--chunk" */ './apps-routes/ValidationApprovalApp'));

const onRedirectCallback = appState => {
    window.history.replaceState(
        {},
        document.title,
        appState && appState.targetUrl
            ? appState.targetUrl
            : window.location.pathname
    );
};

const TokenConfigWrapper = () => {
  useAuthToken();
  return (
    <>
      <Loading />
      <Switch>
          <LoginRoute path="/login" />
          <PrivateRoute path="/" component={RedirectToMiVistaMercado} />
      </Switch>
    </>
  );
};

const ProtectedRoutes = () => {
  return (
    <Auth0Provider
            domain={Auth0Config.DOMAIN}
            clientId={Auth0Config.CLIENT_ID}
            redirectUri={Auth0Config.REDIRECT_URL}
            onRedirectCallback={onRedirectCallback}
            audience={Auth0Config.AUTH0_AUDIENCE}
            scope="openid profile email"
            cacheLocation="localstorage"
        >
          <TokenConfigWrapper />
      </Auth0Provider>
  );
};

const Router = () => (
    <MainWrapper>
        <main>
            <Switch>
                <Route
                    path="/attributes/:countryCode/:categoryId/:productId/:contextInfo"
                    component={Attributes}
                />
                <Route path="/validation" component={Validation} />
                <Route path="/" component={ProtectedRoutes} />
            </Switch>
        </main>
    </MainWrapper>
);

export const RedirectToMiVistaMercado = () => {
  React.useEffect(() => {
    window.location.href = `${Utils.getMonorepoDomain()}${MULTI_PRODUCT_ROUTES.MI_VISTA_MERCADO}`;
  }, []);

  return (
    <div className="spinner">
      <div className="spinner-logo" />
    </div>
  );
};

const Validation = () => {
  return (
    <Switch>
      <Route path='/validation/:currentView/:countryCode/:categoryId/:productId/:contextInfo/:step?' render={props => {
        if (props.match.params.currentView === "edit") {
          return <ValidationApp {...props} />
        }
        if (props.match.params.currentView === "approval") {
          return <ValidationApprovalApp {...props} />
        }
      }} />
    </Switch>
  );
};

const Attributes = (props) => (<AttributesApp {...props} />);

export default Router;
